module.exports = __webpack_public_path__ + "img/maijia_partner2_xinjiang.d2f438ae.png";